export const Add = 'Add';
export const AddN = 'AddN';
export const BatchMatMul = 'BatchMatMul';
export const BatchToSpaceND = 'BatchToSpaceND';
export const BroadcastTo = 'BroadcastTo';
export const Concat = 'Concat';
export const Conv2D = 'Conv2D';
export const Conv2DBackpropFilter = 'Conv2DBackpropFilter';
export const Conv2DBackpropInput = 'Conv2DBackpropInput';
export const Conv3D = 'Conv3D';
export const Conv3DBackpropFilterV2 = 'Conv3DBackpropFilterV2';
export const Conv3DBackpropInputV2 = 'Conv3DBackpropInputV2';
export const DepthToSpace = 'DepthToSpace';
export const DepthwiseConv2dNative = 'DepthwiseConv2dNative';
export const DepthwiseConv2dNativeBackpropFilter = 'DepthwiseConv2dNativeBackpropFilter';
export const DepthwiseConv2dNativeBackpropInput = 'DepthwiseConv2dNativeBackpropInput';
export const Diag = 'Diag';
export const Div = 'Div';
export const Equal = 'Equal';
export const FusedBatchNorm = 'FusedBatchNorm';
export const Greater = 'Greater';
export const GreaterEqual = 'GreaterEqual';
export const Identity = 'Identity';
export const Less = 'Less';
export const LessEqual = 'LessEqual';
export const LRN = 'LRN';
export const LRNBackprop = 'LRNBackprop';
export const MaxPoolWithArgmax = 'MaxPoolWithArgmax';
export const NotEqual = 'NotEqual';
export const NonMaxSuppressionV3 = 'NonMaxSuppressionV3';
export const NonMaxSuppressionV5 = 'NonMaxSuppressionV5';
export const Max = 'Max';
export const OneHot = 'OneHot';
export const PadV2 = 'PadV2';
export const SpaceToBatchND = 'SpaceToBatchND';
export const SplitV = 'SplitV';
export const SquaredDifference = 'SquaredDifference';
export const Square = 'Square';
export const Sub = 'Sub';
export const Tile = 'Tile';
export const Transpose = 'Transpose';
/**
 * TensorFlow.js-only kernels
 */
export const FromPixels = 'FromPixels';
//# sourceMappingURL=kernel_names.js.map